module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    class: _vm.classes,
    attrs: {
      "role": "form"
    }
  }, [(_vm.hasTopSlot) ? _c('div', {
    staticClass: "form-actions top"
  }, [_c('div', {
    staticClass: "btn-set pull-right"
  }, [_vm._t("top")], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-body"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.hasBottomSlot) ? _c('div', {
    staticClass: "form-actions"
  }, [_c('div', {
    staticClass: "btn-set pull-right"
  }, [_vm._t("bottom")], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-373b21a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/formbox-group.vue
// module id = 683
// module chunks = 85